<template>
  <div class="accordion verification-request" role="tablist">
    <h1>{{ protocol.data.requestSectionNumber }}. {{ $t('verification') }}</h1>
    <AccordionCard :state="verificationRequestCard" :hasCardState="false">
      <template v-slot:header>
        {{ $t('verification') }}
      </template>
      <div
        v-for="type in protocol.verification.types"
        :key="type"
        class="flex-row verification-request-row"
      >
        <div class="flex-column name">{{ $t(stateTypeOf(type)) }}</div>
        <div class="flex-column select">
          <div>
            <b-badge class="mr-2" :variant="verificationStateColor(stateOf(stateTypeOf(type)))">
              {{ $t(stateOf(stateTypeOf(type))) }}
            </b-badge>
            <b-button
              v-if="!isBlockReadOnly"
              variant="warning"
              :disabled="!isRequestable(stateTypeOf(type))"
              @click="requestVerification(type)"
            >
              {{ $t('request_verification') }}
            </b-button>
          </div>
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import AccordionCard from '@/components/AccordionCard';
import { verificationStateColor } from '@/helpers/colors';
import { AccessBlockMixin } from '@/mixins/accessBlock';

const UNAUDITED_STATE = 'UNAUDITED';
/** States from which a verification is requested again. */
const REQUESTABLE_STATES = [UNAUDITED_STATE, 'REJECTED'];

/**
 * Section "<n>. Prüfung" below the cards of a protocol's data block (see feature page
 * projekt-protokolle): one row per verification of `protocol.verification` with its state and a
 * request button (the verification block of the protocol requests too). Renders inside the data
 * block's AccessBlock, whose level makes it read-only. `project` is the data block.
 */
export default {
  name: 'ProjectReportVerificationRequest',
  components: { AccordionCard },
  mixins: [AccessBlockMixin],
  props: {
    project: { type: Object, required: true },
    protocol: { type: Object, required: true },
  },
  data() {
    return {
      /** Card of the section in the accordion of the protocol, closed at the start. */
      verificationRequestCard: { name: `${this.protocol.id}-verification-request`, opened: false },
    };
  },
  methods: {
    verificationStateColor,
    stateTypeOf(type) {
      return this.protocol.verification.stateTypeByType[type];
    },
    /** An unset state counts as unaudited, as in the API. */
    stateOf(stateType) {
      return this.project[stateType] || UNAUDITED_STATE;
    },
    isRequestable(stateType) {
      return REQUESTABLE_STATES.includes(this.stateOf(stateType));
    },
    /**
     * Dispatched by its configured name, with the protocol's name of the type argument; a
     * protocol with a single state has none and sends no type.
     */
    requestVerification(type) {
      const { typeArgument } = this.protocol.verification;
      return this.$store.dispatch(this.protocol.data.requestAction, {
        projectNumber: this.project.number,
        ...(typeArgument ? { [typeArgument]: type } : {}),
      });
    },
  },
};
</script>
